import styled from 'styled-components';

export const RecentContainer = styled.div`
	padding-top: 2rem;
	min-height: 12rem;
`;

export const RecentTitle = styled.h5`
	font-weight: 700 !important;
	margin-bottom: 1.25rem !important;
`;

export const RecentList = styled.ul`
	list-style: none;
	margin-left: 0;
`;

export const RecentUser = styled.li`
	margin-bottom: 1rem;
	opacity: 0.5;
	transition: opacity 100ms;

	&:hover {
		opacity: 1;
	}

	a {
		strong {
			font-weight: 500;
			margin-right: 0.5rem;
		}
	}
`;

export const SpinnerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 3rem;
`;
